import { createApp, h, resolveComponent } from 'vue'
import App from './App.vue'
import store from './store.js'
import axios from 'axios'
import WiseCommon from '../commonvue/install.js'

import WiseReservationCommon from './common/installCommon.js'
import WiseCalendarReservation from './CalendarReservation/installCalendar.js'
import WiseGolfReservation from './GolfReservation/installGolf.js'
import WiseEquipmentReservation from './EquipmentReservation/installCalendar.js'

function getQueryParam(key) {
    const params = new URLSearchParams(window.location.search);
    return params.get(key);
}

const token = getQueryParam('access_token')

if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${ token }`
    console.log('[Auth] Set Authorization header from access_token', token)
}

window.moment.locale(window.wisenetwork.langCode);

const app = createApp(App)

app.use(store)
app.use(WiseCommon)
app.use(WiseReservationCommon, { store })
app.use(WiseCalendarReservation, { store })
app.use(WiseGolfReservation, { store })
app.use(WiseEquipmentReservation)
app.mount('#reservationProduct')

const cartApp = createApp({
    render() {
        return h(resolveComponent('wn-cart'), { ref: 'cart' })
    },
    methods: {
        getRows() {
            return this.$refs.cart.getRows();
        }
    }
})

const cartMountTarget = document.querySelector('#shopping-cart')
if (cartMountTarget) {
    const placeholder = document.createElement('div')
    cartMountTarget.replaceWith(placeholder)
    cartApp.use(WiseCommon)
    cartApp.mount(placeholder)
}

window.vueCart = cartApp
